import { createApp } from 'vue';
import i18n from './config/i18n';
import axios from 'axios';
import router from './routes/index';
import * as Sentry from '@sentry/vue';
import {
  Field as ValidationProvider,
  Form as ValidationObserver,
} from 'vee-validate';
import App from '@/App.vue';
import '@/assets/tailwind.css';
import { createPinia } from 'pinia';
import PlainButton from '@/components/shared/PlainButton.vue';
import { swipeDirective } from '@/directives/swipe-directive';
import '@/helpers/validation.helper';

axios.defaults.baseURL = import.meta.env.VITE_APP_API;
axios.defaults.headers.common.Accept = 'application/json';

const pinia = createPinia();
const app = createApp(App);

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    tunnel: import.meta.env.VITE_APP_API + '/tunnel',
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.extraErrorDataIntegration({ depth: 6 }),
    ],
    tracePropagationTargets: ['api.weeezy.com', /^\//],
    tracesSampleRate: 0.1,
    dataCollection: {
      cookies: false,
      httpBodies: [],
      urlQueryParams: { deny: ['token', 'email', 'name', 'search', 'q'] },
    },
  });
}

app.component('ValidationProvider', ValidationProvider);
app.component('ValidationObserver', ValidationObserver);
app.component('PlainButton', PlainButton);

app.use(pinia);
app.use(i18n);
app.use(router);

app.directive('swipe', swipeDirective);

app.mount('#app');
